<template>
  <!--
    作者：gmshop
    时间：2020-06-25
    描述：插件中心-积分抽奖-基础设置
  -->
  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">基础设置</div>
      <el-form-item label="普通链接二维码规则" prop="path" :rules="[{ required: true, message: ' ' }]">
          <el-input placeholder="请输入" v-model="form.path">
          </el-input>
          <p class="gray">小程序扫码抽奖，请在小程序上配置以上 普通链接二维码规则,小程序跳转路径为：packageA/luckDraw/jump</p>
      </el-form-item>
      <el-form-item label="抽奖码长度" prop="length" :rules="[{ required: true, message: ' ' }]">
        <el-input placeholder="请输入" v-model="form.length" type="number">
          </el-input>
      </el-form-item>
      <el-form-item label="奖品抽奖码场景" prop="sweepstakes_status" :rules="[{ required: true, message: ' ' }]">
        <el-radio v-model="form.sweepstakes_status" :label="1">全部场景(进入活动即可抽奖，有码则抽取指定奖品，无抽奖码随机抽取奖品)</el-radio>
        <el-radio v-model="form.sweepstakes_status" :label="2">普通抽奖场(进入活动即可抽奖，奖品随机)</el-radio>
        <el-radio v-model="form.sweepstakes_status" :label="3">扫码抽奖场景(必须扫抽奖码才能抽奖)</el-radio>
      </el-form-item>
    </el-form>

    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>
  </div>
</template>
<script>
import SweepstakesApi from '@/api/sweepstakes.js';
export default {
  data() {
    return {
      form: {
        path: 'h5/packageA/luckDraw/jumb',
        sweepstakes_status: 1,
        length: 12,
      },
      loading: false
    };
  },
  created() {
    console.log(1)
    /*获取列表*/
    this.getSetting();
  },
  methods: {
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      SweepstakesApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          self.form = data.data.vars.values;
        })
        .catch(error => {});
    },
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      SweepstakesApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/sweepstakes/setting/index.vue